<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="CAMPAIGN FORMS"
        :filter="filter"
        placeholder="Search Campaign name"
        @search="handleSearch"
        :hasDropdown="false"
        :hasFilter="false"
        routerPath="/form/detail/0"
      />
      <div class="bg-white border-red p-2 p-lg-3 mt-3">
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
            >
              <template v-slot:cell(name)="data">
                <div>
                  <router-link :to="'/form/detail/' + data.item.id">
                    <b-button variant="link" class="name-link">
                      {{ data.item.name }}
                    </b-button>
                  </router-link>
                </div>
              </template>
              <template v-slot:cell(campaign_type_id)="data">
                <div>
                  {{
                    data.item.campaign_type_id == 1
                      ? "Yearly Campaign"
                      : data.item.campaign_type_id == 2
                      ? "One-Time Campaign"
                      : "Questionnaire Campaign"
                  }}
                </div>
              </template>
              <template v-slot:cell(percent_conversion)="data">
                <span v-if="data.item.is_goal === 1">
                  {{ data.item.percent_conversion }}% ({{
                    data.item.total_conversion
                  }})
                </span>
                <span v-else> - </span>
              </template>
              <template v-slot:cell(start_date)="data">
                <div>{{ data.item.start_date | moment($formatDateNew) }}</div>
                <div class="time-color">
                  {{ data.item.start_date | moment("HH:mm:ss") }}
                </div>
              </template>
              <template v-slot:cell(end_date)="data">
                <div>{{ data.item.end_date | moment($formatDateNew) }}</div>
                <div class="time-color">
                  {{ data.item.end_date | moment("HH:mm:ss") }}
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <div
                  :class="[
                    'd-flex justify-content-center',
                    data.item.status == 1 ? 'text-success' : 'text-danger',
                  ]"
                >
                  {{ data.item.status == 1 ? "Active" : "Inactive" }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <div class="d-flex justify-content-center">
                  <router-link :to="'/form/detail/' + data.item.id">
                    <b-button variant="link" class="text-warning px-1 py-0">
                      <font-awesome-icon icon="pencil-alt" title="Edit" />
                    </b-button>
                  </router-link>
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <Pagination
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
          @handleChangeTake="handleChangePerpage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel";
import Pagination from "@/components/Pagination";
export default {
  components: {
    OtherLoading,
    HeaderPanel,
    Pagination,
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Campaign Name",
          class: "w-200",
        },
        {
          key: "campaign_type_id",
          label: "Campaign Type",
          class: "w-200",
        },
        {
          key: "total_customer",
          label: "Number Of User",
        },
        {
          key: "percent_conversion",
          label: "Goal",
        },
        {
          key: "start_date",
          label: "Valid From",
          class: "w-200",
        },
        {
          key: "end_date",
          label: "Valid To",
          class: "w-200",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      items: [],
      isBusy: false,
      rows: 0,
      filter: {
        search: "",
        page: 1,
        take: 10,
      },
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      showingTo: 10,
      isLoading: true,
    };
  },
  async created() {
    await this.getFormList();
  },
  methods: {
    async getFormList() {
      this.isBusy = true;
      await this.$store.dispatch("getFormList", this.filter);
      let data = this.$store.state.form.formList;
      if (data.result == 1) {
        this.items = data.detail.forms;
        this.rows = data.detail.total;
        this.isBusy = false;
        this.showingTo =
          this.items?.length >= 10 ? this.showingTo : this.items.length;
        this.isLoading = false;
      } else {
        this.errorAlert();
      }
    },
    handleSearch() {
      this.getFormList();
    },
    handleChangePerpage(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.showingTo = value;
      this.getFormList();
    },
    pagination(page) {
      this.filter.page = page;
      this.getFormList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
}
.ft-20 {
  font-size: 20px;
}
::v-deep .input-group-text {
  background-color: #fff;
  padding: 0 0.75rem;
}
</style>
